import { jsx as a, jsxs as pe } from "react/jsx-runtime";
import { c as y } from "./index-65016bfa.mjs";
import ce, { useState as R, useRef as ue } from "react";
import W, { css as D, useTheme as le } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as me } from "./useQuantum-50e8fd44.mjs";
import { b as fe } from "./Aria-f5e019e2.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { D as S } from "./index-2be68378.mjs";
import { Icon as T } from "./icon.js";
import { I as L } from "./helperText-d9646f54.mjs";
import { TextInput as de } from "./textInput.js";
import { u as Ie } from "./useAccessibilityProps-2f24cf29.mjs";
import { u as he } from "./uniqueId-321287e8.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./useWindowSize-88e90e04.mjs";
import "./checkbox.js";
import "./label-33699561.mjs";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./button.js";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./closeButton.js";
import "./iconButton.js";
import "@fcamna/shared-icons";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./menu.js";
import "./radio.js";
const E = "Search Input: Location", be = "https://autosuggest.search.hereapi.com/v1/autosuggest?at=", Ae = "95.7129", ye = "37.0902", Se = "SearchInputLocation", Le = W.div`
  &.InputAndSuggestionWrapper {
    ${({
  theme: {
    components: { searchInputLocation: i }
  }
}) => D(i.InputAndSuggestionWrapper)};
  }
`, P = W.div`
  &.IconWrapper {
    ${({
  theme: {
    components: { searchInputLocation: i }
  }
}) => D(i.IconWrapper)};
  }
`;
function ot({
  textSize: i = "medium",
  longitude: O = Ae,
  latitude: U = ye,
  apiKey: v,
  value: r = { inputValue: "", selectedValue: "" },
  limit: V = 5,
  disabled: p,
  label: B = E,
  // deprecated
  isRequired: C = !1,
  required: d = C,
  showRequiredIndicator: k = d,
  // deprecated
  helperText: I = "",
  isError: h = !1,
  placeholder: F = "Enter your address...",
  onChange: c,
  onBlur: M,
  labelProp: j = { label: B, showRequiredIndicator: k },
  infoProp: q,
  trailingText: G,
  helperTextProp: H = {
    ...!h && I && { defaultProp: { helperText: I } },
    ...h && {
      secondaryProp: { helperText: I }
    }
  },
  noResultText: K,
  inputState: $,
  startAdornmentProp: Q = { hideAdornment: !1 },
  countryCode: g,
  languageCode: X = "en",
  accessibilityOptions: z = {},
  exceedOverflow: J = !1,
  menuDirection: Y = "down_auto",
  ...l
}) {
  var x;
  const Z = me({ label: "Search Input Location" }), s = ce.useRef(null), [b, u] = R(!1), m = ue(he(Se)), [n, N] = R([]), w = {
    inputValue: "",
    selectedValue: ""
  };
  let f = $ || L.NONE;
  $ || (f = h ? L.ERROR : L.NONE);
  const ee = le(), {
    clearButton: te,
    searchIcon: re,
    searchInput: ne
  } = z, oe = fe("combobox", {
    ...ne,
    ariaDisabled: p,
    ariaRequired: d,
    ariaInvalid: f === "caution" || f === "error",
    ariaHaspopup: "listbox",
    ariaControls: `control-${l.id || m.current}`,
    ariaExpanded: b,
    ariaLabelledby: `control-${l.id || m.current}`
  }), ae = Ie("button", {
    ariaLabel: "clear",
    ...te
  }), se = {
    ariaLabel: "search",
    ...re
  }, ie = (e) => {
    const t = e.target.value;
    if (c(
      {
        inputValue: t,
        selectedValue: r == null ? void 0 : r.selectedValue
      },
      e
    ), t.length > 1) {
      let o = `${be}${U},${O}&limit=${V}&lang=${X}&q=${t}&apiKey=${v}`;
      g && (o = `${o}&in=countryCode:${g}`), fetch(o).then((A) => A.json()).then((A) => N(A.items));
    } else
      N([]);
    t.length > 0 ? u(!0) : u(!1);
  }, _ = (e) => {
    s && s.current && (s.current.click(), s.current.focus()), e.stopPropagation(), c(w, e), u(!1);
  };
  return /* @__PURE__ */ a(
    Le,
    {
      className: y(["InputAndSuggestionWrapper"]),
      ...Z,
      children: /* @__PURE__ */ pe(
        S,
        {
          className: "no-filter",
          menuOpen: !p && b,
          exceedOverflow: J,
          onChange: (e, t) => {
            var o;
            c == null || c(
              {
                inputValue: t.label,
                selectedValue: t.label
              },
              e
            ), (o = s.current) == null || o.focus();
          },
          handleMenuOpen: (e) => {
            var t;
            e ? ((t = r == null ? void 0 : r.inputValue) == null ? void 0 : t.length) > 0 && (n == null ? void 0 : n.length) > 0 && u(e) : u(e);
          },
          isDisabled: p,
          uniqueIdentifier: m.current,
          maxItems: Number(V),
          closeOnSelect: !0,
          menuDirection: Y,
          noResultText: K || "No location found",
          children: [
            /* @__PURE__ */ a(S.Control, { children: /* @__PURE__ */ a(
              de,
              {
                labelProp: { label: E, ...j },
                infoProp: {
                  infoText: "",
                  infoType: "tooltip",
                  popupTipHeader: "Info",
                  ...q
                },
                startAdornmentProp: {
                  startAdornment: Q.hideAdornment ? "" : /* @__PURE__ */ a(
                    P,
                    {
                      className: y(["IconWrapper"]),
                      ...se,
                      tabIndex: -1,
                      children: /* @__PURE__ */ a(T, { name: "search" })
                    }
                  )
                },
                endAdornmentProp: {
                  endAdornment: r.inputValue && !p ? /* @__PURE__ */ a(
                    P,
                    {
                      onClick: _,
                      className: y(["IconWrapper", "IconWrapper--CloseButtonWrapper"]),
                      onKeyDown: (e) => {
                        (e.code === "Enter" || e.code === "Space") && (e.preventDefault(), _(e));
                      },
                      ...ae,
                      children: /* @__PURE__ */ a(
                        T,
                        {
                          name: "cancelCloseFilled",
                          style: ee.components.searchInputLocation.IconStyle
                        }
                      )
                    }
                  ) : void 0
                },
                value: r.inputValue,
                type: "text",
                textSize: i,
                required: d,
                inputRef: s,
                onChange: ie,
                disabled: p,
                placeholder: F,
                onBlur: M,
                inputState: f,
                helperTextProp: b ? void 0 : H,
                onKeyUp: (e) => {
                  e.key === " " && e.stopPropagation();
                },
                trailingText: G,
                ...l,
                role: "combobox",
                id: `control-${l.id || m.current}`,
                ...oe
              }
            ) }),
            ((x = r == null ? void 0 : r.inputValue) == null ? void 0 : x.length) > 0 && n && (n == null ? void 0 : n.length) > 0 && (n == null ? void 0 : n.map(({ title: e, id: t }, o) => /* @__PURE__ */ a(
              S.Item,
              {
                id: t || `${o}`,
                label: e,
                value: e,
                isSelected: r.selectedValue === e
              },
              t || o
            )))
          ]
        }
      )
    }
  );
}
export {
  ot as SearchInputLocation
};
